import React from "react";
/* import { render } from "react-dom"; */
import { BrowserRouter as Router, Routes, Route/* , Switch */ } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { getStore } from "./store";
/* 
import "./common/css/index-BwepVivJ.css"; */
/* import "./common/css/index-B4_Bup0D.css"; */
import "./common/css/review-CvWskD9W.css";


import "./assets/vendor/fonts/materialdesignicons.css";
import "./assets/vendor/fonts/fontawesome.css";
import "./assets/vendor/css/rtl/core.css";
import "./assets/vendor/css/rtl/theme-default.css";
import "./assets/css/demo.css";
import "./assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "./assets/vendor/libs/node-waves/node-waves.css";
import "./assets/vendor/libs/typeahead-js/typeahead.css";
import "./assets/vendor/libs/formvalidation/dist/css/formValidation.min.css";
import "./assets/vendor/css/pages/page-auth.css";
import "./assets/vendor/libs/toastr/toastr.css";
import "./assets/vendor/libs/dropzone/dropzone.css";

import "./common/css/slick.css";
import "./common/css/custom.css";
import "./common/css/reservation.css";

//import Logout from "./components/Myaccount/Logout";

import Clientlogin from "./components/Clientpanel/Auth/Login";

/* import Email from "./components/Clientpanel/Reports/Email"; */
import EmailBuilder from "./components/Clientpanel/Email/Form";

/* import Refpage from "./components/Layout/Refpage"; */
import Logout from "./components/Layout/Logout";
/* import Page404 from "./Page404"; */
import { AuthProvider } from "./hooks/useAuth";

import MasterPanelRoutes from "./MasterPanelRoutes";
import ClientPanelRoutes from "./ClientPanelRoutes";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
/* import Editor from "./components/Clientpanel/Outlet/editor"; */

const store = getStore();
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Router>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Clientlogin />} />
          <Route path="/emailBuilder" element={<EmailBuilder />} />
          <Route path="/masterpanel/*" element={<MasterPanelRoutes />} />
          <Route path="/clientpanel/*" element={<ClientPanelRoutes />} />
          <Route path={"/logout/:LoginType?"} element={<Logout />} />
          <Route path={"/logout"} element={<Logout />} />
        </Routes>
      </AuthProvider>
    </Router>
  </Provider>
);
